var pug = require("!../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function (filterModel, listingType, sorts, terms) {const labelMap = {
    name: (x => terms[x] || x)('Description'),
    partNumber: (x => terms[x] || x)('Part Number'),
};
const labelMapAen = {
    partNumber: (x => terms[x] || x)('Document Number'),
    name: (x => terms[x] || x)('Document Title'),
    documentCategory: (x => terms[x] || x)('Document Category'),
};
const cssClassMapAen = {
    partNumber: "documentNumber"
};

if (listingType === 'Common') {
pug_html = pug_html + "\u003Cdiv class=\"product-list__headers\"\u003E\u003Cdiv class=\"product-list__header product-list__header--popular\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"product-list__header\"\u003E\u003C\u002Fdiv\u003E";
// iterate sorts
;(function(){
  var $$obj = sorts;
  if ('number' == typeof $$obj.length) {
      for (var pug_index0 = 0, $$l = $$obj.length; pug_index0 < $$l; pug_index0++) {
        var sort = $$obj[pug_index0];
const isActive = filterModel.sort === sort;
let htmlClass = 'product-list__header__button' + ' product-list__header__button--' + sort + (isActive ? ' active' : '');
htmlClass += (' ' + filterModel._order);
pug_html = pug_html + "\u003Cdiv class=\"product-list__header\"\u003E\u003Cbutton" + (pug.attr("class", pug.classes([htmlClass], [true]), false, true)+pug.attr("data-sort", sort, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = labelMap[sort]) ? "" : pug_interp)) + "\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index0 in $$obj) {
      $$l++;
      var sort = $$obj[pug_index0];
const isActive = filterModel.sort === sort;
let htmlClass = 'product-list__header__button' + ' product-list__header__button--' + sort + (isActive ? ' active' : '');
htmlClass += (' ' + filterModel._order);
pug_html = pug_html + "\u003Cdiv class=\"product-list__header\"\u003E\u003Cbutton" + (pug.attr("class", pug.classes([htmlClass], [true]), false, true)+pug.attr("data-sort", sort, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = labelMap[sort]) ? "" : pug_interp)) + "\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003Cdiv class=\"product-list__header\"\u003E&nbsp;\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
}
if (listingType === 'Specialized - Application Engineering Notes') {
pug_html = pug_html + "\u003Cdiv class=\"product-list__headers\"\u003E";
// iterate sorts
;(function(){
  var $$obj = sorts;
  if ('number' == typeof $$obj.length) {
      for (var pug_index1 = 0, $$l = $$obj.length; pug_index1 < $$l; pug_index1++) {
        var sort = $$obj[pug_index1];
const isActive = filterModel.sort === sort;
let htmlClass = 'product-list__header__button' + ' product-list__header__button--' + (cssClassMapAen[sort] || sort) + (isActive ? ' active' : '');
htmlClass += (' ' + filterModel._order);
pug_html = pug_html + "\u003Cdiv class=\"product-list__header\"\u003E\u003Cbutton" + (pug.attr("class", pug.classes([htmlClass], [true]), false, true)+pug.attr("data-sort", sort, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = labelMapAen[sort]) ? "" : pug_interp)) + "\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index1 in $$obj) {
      $$l++;
      var sort = $$obj[pug_index1];
const isActive = filterModel.sort === sort;
let htmlClass = 'product-list__header__button' + ' product-list__header__button--' + (cssClassMapAen[sort] || sort) + (isActive ? ' active' : '');
htmlClass += (' ' + filterModel._order);
pug_html = pug_html + "\u003Cdiv class=\"product-list__header\"\u003E\u003Cbutton" + (pug.attr("class", pug.classes([htmlClass], [true]), false, true)+pug.attr("data-sort", sort, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = labelMapAen[sort]) ? "" : pug_interp)) + "\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003Cdiv class=\"product-list__header\"\u003E&nbsp;\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
}}.call(this,"filterModel" in locals_for_with?locals_for_with.filterModel:typeof filterModel!=="undefined"?filterModel:undefined,"listingType" in locals_for_with?locals_for_with.listingType:typeof listingType!=="undefined"?listingType:undefined,"sorts" in locals_for_with?locals_for_with.sorts:typeof sorts!=="undefined"?sorts:undefined,"terms" in locals_for_with?locals_for_with.terms:typeof terms!=="undefined"?terms:undefined));;return pug_html;};
module.exports = template;